module.exports = __webpack_public_path__ + "static/media/sensable_32.cd451384.gif";